import {Injectable} from '@angular/core';
import {PersonalOnboardingDialogComponent} from '../../../app/personal-onboarding-dialog/personal-onboarding-dialog.component';
import {MainOnboardingDialogComponent} from '../../../app/main-onboarding-dialog/main-onboarding-dialog.component';
import {LocalStorageService} from '../local-storage/local-storage.service';
import {MatDialog} from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  public static readonly mainOnboardingAgreementKey = 'mainOnboardingAgreement';
  public static readonly personalOnboardingAgreementKey = 'personalOnboardingAgreement';

  constructor(private readonly localStorageService: LocalStorageService,
              public dialog: MatDialog) { }

  public removeOnboardingAgreements(): void {
    this.localStorageService.removeItem(OnboardingService.mainOnboardingAgreementKey);
    this.localStorageService.removeItem(OnboardingService.personalOnboardingAgreementKey);
  }

  public openMainOnboardingDialog(): void {
    const dialogRef = this.dialog.open(MainOnboardingDialogComponent, {
      ariaLabel: 'Einführung - Anmeldung',
      // Setzt die von Angular Material definerte maximale Breite zurück.
      maxWidth: '',
      // `w-full` für 100 % Breite sowie `max-w-md` um die maximale Breite auf `448px` zu beschränken.
      panelClass: ['w-full', '!max-w-md']
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.localStorageService.setBooleanItem(OnboardingService.mainOnboardingAgreementKey, true);
      }
    });
  }

  public mainOnboardingAgreement(): boolean {
    return Boolean(this.localStorageService.getBooleanItem(OnboardingService.mainOnboardingAgreementKey));
  }

  public openPersonalOnboardingDialog(): void {
    const dialogRef = this.dialog.open(PersonalOnboardingDialogComponent, {
      ariaLabel: 'Einführung - Personalisierte Ansicht',
      // Setzt die von Angular Material definerte maximale Breite zurück.
      maxWidth: '',
      // `w-full` für 100 % Breite sowie `max-w-md` um die maximale Breite auf `448px` zu beschränken.
      panelClass: ['w-full', '!max-w-md']
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.localStorageService.setBooleanItem(OnboardingService.personalOnboardingAgreementKey, true);
      }
    });
  }

  public personalOnboardingAgreement(): boolean {
    return Boolean(this.localStorageService.getBooleanItem(OnboardingService.personalOnboardingAgreementKey));
  }

}
